import React, {useState, useEffect} from "react"
import styled from "styled-components"
import LivePoint from "./LivePoint/LivePoint";

const Styled ={
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    BtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,
    Inputs:styled.input`
        width:75%;
        height:40px;
        border-radius: 20px;
        border:1px solid #eee;
        padding:10px;
        font-size:20px;
    `,
    NextBtn:styled.div`
        width:50px;
        height:40px;
        padding:10px;
        border-radius: 10px;
        background-color: gold;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: row;
        :hover{
            opacity:50%;
            cursor:pointer;
        }
    `,
}
interface PropsType{
    setFamily:any;
    Family:number
    Points : number;
    setPoints : any;
}
const SoloPay=(props:PropsType)=>{
    const Family = props.Family
    const setFamily = props.setFamily
    const setPoints = props.setPoints
    const Points = props.Points
    
    
    const [Pay, setPay] = useState<any>(0)
    const [YearPay, setYearPay] = useState<any>()
    const [MoneyRank, setMoneyRank] = useState<number>(0) //소득 기준
    const [NextPage, setNextPage] = useState<boolean>(false)
    const SoloMoney =()=>{
        if(Family === 3 || Family <=3 ){
            //38245920원보다 작아야함
            if(MoneyRank <= 38245920){
                setPoints(Points + 1)
            }else if(MoneyRank >= 38245920){
                setPoints(Points)
            }else{
                //
            }
        }else if(Family === 4){
            //46812384원
            if(MoneyRank <= 46812384){
                setPoints(Points + 1)
            }else if(MoneyRank >= 46812384){
                setPoints(Points)
            }else{
                //
            }
        }else if(Family === 5){
            //55270776원
            if(MoneyRank <= 55270776){
                setPoints(Points + 1)
            }else if(MoneyRank >= 55270776){
                setPoints(Points)
            }else{
                //
            }
        }else if(Family === 6){
            //63634584원
            if(MoneyRank <= 63634584){
                setPoints(Points + 1)
            }else if(MoneyRank >= 63634584){
                setPoints(Points)
            }else{
                //
            }
        }else{
            //        
        }
    }
    const DuoMoney =()=>{
        if(Family === 3 || Family <=3 ){
            //47807400원
            if(MoneyRank <= 47807400){
                setPoints(Points + 1)
            }else if(MoneyRank >= 47807400){
                setPoints(Points)
            }else{
                //
            }
        }else if(Family === 4){
            //58515480원
            if(MoneyRank <= 58515480){
                setPoints(Points + 1)
            }else if(MoneyRank >= 58515480){
                setPoints(Points)
            }else{
                //
            }
        }else if(Family === 5){
            //69088476원
            if(MoneyRank <= 69088476){
                setPoints(Points + 1)
            }else if(MoneyRank >= 69088476){
                setPoints(Points)
            }else{
                //
            }
        }else if(Family === 6){
            //79543236원
            if(MoneyRank <= 79543236){
                setPoints(Points + 1)
            }else if(MoneyRank >= 79543236){
                setPoints(Points)
            }else{
                //
            }
        }else{
            if(MoneyRank >= 79543236){
                setPoints(Points)
            }else{
                //
            }
        }
    }
    const ChangeNum = ()=>{
        const NumPay = parseInt(Pay)
        setPay(NumPay)
        SoloMoney()
        setNextPage(true)
    }
    useEffect(()=>{
            const Length:string = Pay.toString()
            if(Pay.length === 4){
                const AddPoint = Length.replace(/000/g, ",000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 5){
                const AddPoint = Length.replace(/0000/g, "0,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 6){
                const AddPoint = Length.replace(/00000/g, "00,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 7 ){
                const AddPoint = Length.replace(/000000/g, ",000,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 8){
                const AddPoint = Length.replace(/0000000/g, "0,000,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 9){
                const AddPoint = Length.replace(/00000000/g, "00,000,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 10){
                const AddPoint = Length.replace(/000000000/g, ",000,000,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 11){
                const AddPoint = Length.replace(/0000000000/g, "0,000,000,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 12){
                const AddPoint = Length.replace(/00000000000/g, "00,000,000,000")
                setYearPay(AddPoint + "원")
            }else if(Pay.length === 13){
                const AddPoint = Length.replace(/000000000000/g, ",000,000,000,000")
                setYearPay(AddPoint + "원")
            }else{
                setYearPay(Pay + "원")
                setYearPay(Length + "원")
            }
    },[Pay])
    const PayHandler =(event:any)=>{
        setPay(event.target.value)
    }
    if(NextPage === false){
        return(
            <Styled.Wrap>
                <Styled.LittleTitleFont>경제활동 하시는 분의 <br />정확한 연봉을 적어주세요.</Styled.LittleTitleFont>
                <Styled.Fonts>연봉: {YearPay}</Styled.Fonts>
                <Styled.BtnWrap>
                    <Styled.Inputs onChange=
                        // (event)=>{
                        // setPay(event.target.value)
                        {(event:any)=>{PayHandler(event)}}
                    // }}
                    />
                    <Styled.NextBtn onClick={ChangeNum}>
                        <Styled.Fonts>완료</Styled.Fonts>
                    </Styled.NextBtn>
                </Styled.BtnWrap>
            </Styled.Wrap>
        )
    }else{
        return(
            <LivePoint 
                setPoints={setPoints}
                Points={Points}
            />
        )
    }
}

export default SoloPay